<template>
  <div class="wordDict absolute z-10 border borderRed bg-white cursor-default p-2 px-4 pb-4 scrollBar shadow-md" v-if="content">
    <div class="bg-white relative">
      <div class="flex items-center">
        <h5 class="font-black text-xl mr-2" v-if="content.key" v-html="forceToJap(content.key)" :class="{ 'textColorRed': !isJPN, 'jpnOrange': isJPN }"></h5>
        <a @click="PlayAudioDict()" class="cursor-pointer h-6 w-6 bgLiveBlack rounded-full flex items-center justify-center">
          <font-awesome-icon icon="volume-up" class="text-sm text-white " />
        </a>
      </div>
      <div class="translation_KK text-sm textColorDarkBlack flex flex-wrap">
        <span v-if="checkPhon">{{ checkPhon }}</span>
        <span class="ml-2" v-if="content.part_of_speech">{{ content.part_of_speech }}</span>
      </div>
      <p class="whitespace-pre-line textColorDarkBlack"> {{ content.expl }}</p>
      <a class="cursor-pointer absolute top-0 right-0 p-1 textColorDarkBlack" @click.prevent.stop="closeDict"><font-awesome-icon icon="times" /></a>
    </div>
    <audio muted id='audio' :src="`${BaseUrl}/livelibrary/Dict/Word/${content.key}/audio?lang=${checkLang}`" controlos="controls" ref="audioplayer"></audio>
  </div>
</template>

<script>
import langMixin from '@/components/modules/langMixin'
export default {
  name: 'WordDict',

  data () {
    return {

    }
  },
  mixins: [
    langMixin
  ],
  props: {
    content: {
      type: Object
    }
  },
  computed: {
    isJPN () {
      if (this.checkJPN(this.getOnlyJp(this.content.key))) {
        return true
      }
      return false
    },
    BaseUrl () {
      if (process.env.NODE_ENV === 'production') {
        return 'https://api.liveabc.com/v1'
      } else {
        return 'https://apitest.liveabc.com/v1'
      }
    },
    checkLang () {
      if (this.checkJPN(this.getOnlyJp(this.content.key))) {
        return 'ja'
      }
      return 'en'
    },
    checkPhon () {
      let self = this
      if (self.content.phon && self.content.phon.indexOf('[') > -1 && self.content.phon.indexOf(']') > -1) {
        return self.content.phon
      } else if (self.content.phon && self.content.phon.indexOf('[') === -1 && self.content.phon.indexOf(']') === -1) {
        return '[' + self.content.phon + ']'
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.PlayAudioDict()
  },
  methods: {
    closeDict () {
      let self = this
      self.$emit('closeDict', -1)
    },
    PlayAudioDict () {
      let self = this
      if (self.$refs.audioplayer) {
        let audioplayer = self.$refs.audioplayer
        // 判斷是否撥放中
        audioplayer.onplaying = () => {
          self.isPlaying = true
        }
        audioplayer.onpause = () => {
          self.isPlaying = false
        }
        // 播放切換
        if (self.isPlaying) {
          audioplayer.pause()
          audioplayer.currentTime = 0
          self.isPlaying = false
        } else {
          audioplayer.play()
          self.isPlaying = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wordDict {
  width: 20em;
  height: 10em;
  overflow-y: scroll;
  left: 0%;
  top: 115%;
}
.jpnOrange {
  color: #CE6D39;
}
// .scrollBar {
//   max-height: 500px;
//   overflow-y: scroll;
// }
.scrollBar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
}

.scrollBar::-webkit-scrollbar {
  width: 6px;
}

.scrollBar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
</style>
